import ivclass from '@invideoio/web-shared/Modules/IVClass';
import React from 'react';

interface StatementProps {
  statement: string;
}

const Statement = (props: StatementProps) => {
  const { statement } = props;

  return (
    <div
      className={ivclass('iv-relative', 'xl:iv-mt-40 iv-mt-35 sm:iv-mt-[24px]')}
    >
      <sup
        className={ivclass(
          'iv-absolute',
          'xl:iv-left-[-29px] iv-left-[-23px] sm:iv-left-[-15px]',
          'iv-mt-6 sm:iv-mt-5',
          'iv-text-deep-blue',
          'xl:iv-text-heading-2xl iv-text-heading-m sm:iv-text-heading-xs',
          'iv-font-extrabold',
        )}
      >
        “
      </sup>
      <div
        className={ivclass(
          'xl:iv-h-[400px] iv-h-[348px] sm:iv-h-[250px]',
          'xl:iv-mb-[65px] iv-mb-25 sm:iv-mb-25',
          'iv-overflow-ellipsis iv-overflow-hidden',
          'iv-text-grey-100',
          'xl:iv-m-heading-xl iv-m-heading-s sm:iv-m-heading-2xs',
          'xl:iv-text-heading-xl iv-text-heading-s sm:iv-text-heading-2xs',
          'iv-font-extrabold',
        )}
      >
        {statement}
      </div>
    </div>
  );
};

export default Statement;
